import { Routes, Route } from "react-router-dom"
import HomeInScreen from "../modules/homein/principal/screens/HomeInScreen"
import ScrollToTop from "./ScrollToTop"

const RouterHomeIn = () => {
    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route path="/*" element={<HomeInScreen />} />
            </Routes>
        </>
    )
}

export default RouterHomeIn